const WhyThisExists = () => {
  return (
<section className="py-14 md:py-18 bg-section-alt">
      <div className="container-narrow">
        <div className="max-w-[840px] mx-auto text-center space-y-6">
          <h2 className="text-2xl md:text-3xl font-semibold text-primary">
            How we build websites
          </h2>
          <div className="space-y-4 text-lg text-soft leading-relaxed">
            <p>
              We build websites with a focus on clarity, structure, and ease of contact — not trends or gimmicks.
            </p>
            <p>
              Some clients are adding a standalone site alongside a brokerage or directory page. Others are improving an existing real estate website. In both cases, the goal is the same: a clean, professional site that clearly explains what you do and makes it easy for the right people to reach out.
            </p>
            <p>
              We simplify layouts, tighten messaging, and remove distractions so visitors quickly understand who you help and how to contact you.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyThisExists;
